import { connect } from 'react-redux';
import SelectContent from '../../../components/navbar/SelectContent';
import { setSnackAlert } from 'core/slices/snackAlert';
import { profile, sucursal_id } from 'core/selectors';
import { setSucursalId } from 'core/slices/users';

export default connect(
  state => ({
    profile: profile(state),
    sucursal_id: sucursal_id(state),
  }),
  { setSnackAlert, setSucursalId },
)(SelectContent);
